import { useMutation, useQuery } from '@tanstack/react-query';
import { getDentistAttestation, updateDentistAttestation } from '../../../../services/credentials';
import { showSuccessMessage } from '../../../../utils';
import { RemoteConfigUtils } from '../../../../utils/RemoteConfigUtils';
import { formatDsoName } from '../../../../utils/String';

export const useDentistDsoAttestationToggle = (officeId, dsoCode) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['getDentistAttestation', `${officeId}-${dsoCode}`],
    queryFn: () => getDentistAttestation(officeId, dsoCode),
  });

  const isEnabled = !!data?.data?.data?.is_enabled;

  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      updateDentistAttestation({
        officeId,
        code: dsoCode,
        isEnabled: !isEnabled,
      }),
    onMutate: () => {},
    onSuccess: async () => {
      await refetch();
      showSuccessMessage({ message: `${formatDsoName(dsoCode)} Attestation Updated` });
    },
  });

  return { isEnabled, isLoading: isLoading || isPending, onToggle: mutate };
};

export const getDsoCodesFromRemoteConfig = () =>
  Object.keys(RemoteConfigUtils.getDsoNameConsents());
